import React, { useEffect, useRef, useState } from 'react';
import { Alert, Spinner } from 'react-bootstrap';

const scripts = new Map();
function load(url) {
  if (!scripts.has(url)) scripts.set(url, new Promise((resolve, reject) => {
    const script = document.createElement('script'); script.src = `${url}/external_api.js`; script.async = true;
    script.onload = resolve; script.onerror = () => { scripts.delete(url); reject(new Error('Jitsi indisponível')); };
    document.head.appendChild(script);
  }));
  return scripts.get(url);
}
export default function JitsiFrame({ credentials, onEvent }) {
  const container = useRef(null);
  const event = useRef(onEvent); event.current = onEvent;
  const [error, setError] = useState('');
  const [ready, setReady] = useState(false);
  useEffect(() => {
    let active = true, api;
    const url = new URL(credentials.server_url);
    if (url.protocol !== 'https:') { setError('O servidor de vídeo deve usar HTTPS.'); return; }
    load(url.origin).then(() => {
      if (!active || !container.current) return;
      api = new window.JitsiMeetExternalAPI(url.host, {
        roomName: credentials.room, jwt: credentials.jwt, parentNode: container.current,
        width: '100%', height: '100%', lang: 'ptBR', userInfo: { displayName: credentials.display_name },
        configOverwrite: { prejoinConfig: { enabled: true }, disableDeepLinking: true,
          disableInviteFunctions: true, fileRecordingsEnabled: false, liveStreamingEnabled: false,
          localRecording: { enabled: false }, toolbarButtons: ['microphone','camera','hangup','settings','tileview'] },
      });
      Object.entries({ videoConferenceJoined: 'joined', videoConferenceLeft: 'left', cameraError: 'camera_error', micError: 'microphone_error', peerConnectionFailure: 'connection_failed' }).forEach(([name,value]) => {
        api.addListener(name, () => { if(active) event.current?.(value); });
      });
      api.addListener('errorOccurred', () => { if(active) { setError('A conexão de vídeo falhou. Confira a internet e use Reconectar.'); event.current?.('connection_failed'); } });
      setReady(true);
    }).catch(() => { if (active) { setError('Não foi possível carregar o vídeo. Confira a conexão e tente reconectar.'); event.current?.('connection_failed'); } });
    return () => { active = false; api?.dispose(); };
  }, [credentials]);
  return <div className="telehealth-jitsi-frame" style={{ height: 'min(70vh, 650px)', minHeight: 360, background: '#102e38', borderRadius: 16, overflow: 'hidden' }}>
    {error && <Alert variant="warning">{error}</Alert>}
    {!ready && !error && <Spinner animation="border" className="m-3 text-light" />}
    <div ref={container} style={{ height: '100%', width: '100%' }} />
  </div>;
}
